'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { useCallback, useEffect } from 'react';
import { useLocalStorage } from 'usehooks-ts';
import { useWhitelistOverlay } from '@/modules/whitelist/hooks/use-whitelist-overlay';
import { WHITELIST_OVERLAY_STORAGE_KEY } from '@/modules/whitelist/lib/constants';
import { SuccessView } from '../success-view';
import { WhitelistForm } from '../whitelist-form';
function WhitelistOverlay() {
  const $ = _c(10);
  const shouldShow = useWhitelistOverlay();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      initializeWithValue: false
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [isSubmitted, setIsSubmitted] = useLocalStorage(WHITELIST_OVERLAY_STORAGE_KEY, false, t0);
  let t1;
  let t2;
  if ($[1] !== shouldShow) {
    t1 = () => {
      if (typeof window === "undefined" || !shouldShow) {
        return;
      }
      const body = document.body;
      body.style.overflow = "hidden";
      return () => {
        body.style.overflow = "auto";
      };
    };
    t2 = [shouldShow];
    $[1] = shouldShow;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== setIsSubmitted) {
    t3 = () => {
      setIsSubmitted(true);
    };
    $[4] = setIsSubmitted;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleSuccess = t3;
  if (!shouldShow) {
    return null;
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn("bg-background relative h-full", "before:to-background before:absolute before:-top-[118px] before:right-0 before:left-0 before:h-30 before:bg-gradient-to-b before:from-transparent before:content-[\"\"]");
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== handleSuccess || $[8] !== isSubmitted) {
    t5 = <div className="fixed right-0 bottom-0 left-0 z-50 h-[calc(100vh-12rem)] sm:h-[calc(100vh-18rem)]"><div className={t4}><div className="container flex h-full w-full flex-col items-center justify-center px-4">{isSubmitted ? <SuccessView /> : <WhitelistForm onSuccess={handleSuccess} />}</div></div></div>;
    $[7] = handleSuccess;
    $[8] = isSubmitted;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
export { WhitelistOverlay };